import { Select, Tooltip } from "antd";
import React from "react";
import { Component } from "../../../types";
import styles from "./ComponentSelector.module.css";

type ComponentSelectorProps = {
  className?: string;
  components: Component[];
  onSelect?: (value: string) => void;
};

export const ComponentSelector = (props: ComponentSelectorProps) => {
  // Helper function to get text content from option value
  const getLabelText = (option: any): string => {
    if (!option) {
      return "";
    }

    // Find component by id/value and return its name
    const componentId = option.value || option.key;
    const component = props.components.find((c) => c.id === componentId);
    return component?.name || "";
  };

  return (
    <Select
      showSearch
      placeholder="Select..."
      onChange={props.onSelect}
      filterOption={(input, option) => {
        const labelText = getLabelText(option);
        return labelText.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
      filterSort={(optionA, optionB) => {
        const textA = getLabelText(optionA);
        const textB = getLabelText(optionB);
        return textA.toLowerCase().localeCompare(textB.toLowerCase());
      }}
      options={props.components.map((component) => {
        const componentInfo = `${
          component.subcontractor ? ` | ${component.subcontractor?.name}` : ""
        } | ${component.object}${
          component.tags.length > 0 ? `| ${component.tags.join(" | ")}` : ""
        }`;
        const title = `${component.name}${componentInfo}`;
        return {
          key: component.id,
          value: component.id,
          label: (
            <Tooltip title={title}>
              <span>
                {component.name}
                <span className={styles.componentInfo}>{componentInfo}</span>
              </span>
            </Tooltip>
          ),
        };
      })}
    />
  );
};
